// eslint-disable-next-line import/prefer-default-export
export const AB_TEST_ID = {
  FAST_PAY_BTN: 'id_85',
  RESET_STATISTIC: 'id_84',
};
